export default __webpack_public_path__ + "static/cruiselogo_atlas-c2ed662e23a37014851913d583b4d4db.png";